import { createAction, props, createReducer, on } from '@ngrx/store';
import { CopyDataInitState } from '../models/copy.interface';

// Action definitions using createAction
export const updateCopy = createAction(
  '[Copy] Update Copy',
  props<{ payload: CopyDataInitState }>()
);

export const refreshCopy = createAction(
  '[Copy] Refresh Copy',
  props<{ payload: CopyDataInitState }>()
);

export const resetCopy = createAction(
  '[Copy] Reset Copy'
);

export const updateLanguage = createAction(
  '[Copy] Update Language',
  props<{ payload: { language: string, languageCode: string } }>()
);

// Initial state
const initState: CopyDataInitState = {
  copyLoaded: false,
  carrierKey: {},
  airlines: [
    { carrier: '', pages: [] }
  ],
  language: '',
  languageCode: 'en'
};

// Reducer using createReducer and on
export const copyReducer = createReducer(
  initState,
  on(updateCopy, (state, { payload }) => ({ ...payload })),
  on(refreshCopy, (state, { payload }) => ({ ...payload })),
  on(resetCopy, () => ({ ...initState })),
  on(updateLanguage, (state, { payload }) => ({
    ...state,
    language: payload.language,
    languageCode: payload.languageCode
  }))
);
